import { render } from "./LoadingPage.vue?vue&type=template&id=2965293a&ts=true"
import script from "./LoadingPage.vue?vue&type=script&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&lang=ts"

import "./LoadingPage.vue?vue&type=style&index=0&id=2965293a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__